// src/components/PrivacyPolicy.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import logoGif from '../logo.gif';
import '../../src/App.css';
const PrivacyPolicy = () => {
  return (
    <motion.div
      className="privacy-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <header className="privacy-header">
        <Link to="/" className="logo-link">
          <motion.img 
            src={logoGif} 
            alt="Folivana Music Logo"
            className="privacy-logo"
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 400 }}
          />
          <h1>Folivana Music</h1>
        </Link>
      </header>

      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>
        
        <section>
          <h2>1. Information We Collect</h2>
          <p>
            Folivana Music collects the following information when you use our bot:
          </p>
          <ul>
            <li>Server IDs where the bot is added</li>
            <li>User IDs of users interacting with the bot</li>
            <li>Channel IDs where commands are used</li>
            <li>Command usage data (without message content)</li>
            <li>Song requests and queue information</li>
          </ul>
        </section>
        
        <section>
          <h2>2. How We Use Your Information</h2>
          <p>The information we collect is used to:</p>
          <ul>
            <li>Provide and maintain our service</li>
            <li>Improve user experience</li>
            <li>Monitor bot performance and usage</li>
            <li>Prevent abuse and enforce our Terms of Service</li>
            <li>Generate aggregate statistics (non-personal)</li>
          </ul>
        </section>
        
        <section>
          <h2>3. Data Storage and Security</h2>
          <p>
            We store your data securely and implement industry-standard measures to protect it:
          </p>
          <ul>
            <li>Data is encrypted in transit and at rest</li>
            <li>Access to data is restricted to essential personnel only</li>
            <li>Regular security audits are performed</li>
          </ul>
        </section>
        
        <section>
          <h2>4. Data Retention</h2>
          <p>
            We retain server configuration data indefinitely unless a server removes the bot.
            Command usage data is retained for 30 days for analytics purposes.
          </p>
        </section>
        
        <section>
          <h2>5. Your Rights</h2>
          <p>
            Under GDPR and other privacy laws, you have the right to:
          </p>
          <ul>
            <li>Request access to your data</li>
            <li>Request correction of your data</li>
            <li>Request deletion of your data</li>
            <li>Object to processing of your data</li>
          </ul>
          <p>
            To exercise these rights, please contact us at privacy@folivana-music.com.
          </p>
        </section>
        
        <section>
          <h2>6. Changes to This Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes
            by posting the new Privacy Policy on this page and updating the "Last Updated" date.
          </p>
        </section>
        
        <section>
          <h2>7. Contact Us</h2>
          <p>
          If you have any questions about these Terms, please contact us at Support Server
          </p>
        
        </section>

        <div className="back-to-home">
          <Link to="/" className="back-button">
            ← Back to Home
          </Link>
        </div>
       
      </div>
    <motion.footer 
    className="footer"
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true, margin: "0px 0px -100px 0px" }}
    transition={{ duration: 0.6 }}
  >
    <div className="footer-content">
      <div className="footer-main">
        <div className="footer-logo">
          <motion.img 
            src={logoGif} 
            alt="Music Bot Logo"
            className="footer-logo-img"
            whileHover={{ scale: 1.1 }}
            transition={{ type: "spring", stiffness: 400 }}
            loading="lazy"
          />
          <h3>Folivana Music</h3>
        </div>

        <div className="footer-legal-links">
          <Link to="/PrivacyPolicy">Privacy Policy</Link>
          <span>•</span>
           <Link to="/tos">Terms of Service</Link>
         </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Folivana Music. All rights reserved.</p>
        <div className="footer-credits">
          <span>Made with ❤️ by just-Nixx</span>
        </div>
      </div>
    </div>
  </motion.footer>
    </motion.div>



  );
};

export default PrivacyPolicy;